import { ThemeProvider } from '@mui/material/styles';
import { HomeContainer } from '../src/Containers';
import { pinTrackingTheme } from './Theme/Pin-Tracking.Theme';

export const App = () => {
  return (
    <ThemeProvider theme={pinTrackingTheme}>
      <HomeContainer />
    </ThemeProvider>
  );
};
